export default __webpack_public_path__ + "static/media/jcb.4c574840.svg";